import { render, staticRenderFns } from "./CarUseView.vue?vue&type=template&id=3bef0643"
import script from "./CarUseView.vue?vue&type=script&lang=js"
export * from "./CarUseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports